import React, { Component} from "react";
import NavTab from '../../../../components/common/global_layout/navTab'
import { Container} from "reactstrap";
import AdvancedSearchLocation from '../../../../components/common/Cars/advancedSearchLocation'
import CarCard from '../../../../components/common/Cars/carCard'
import Footer from '../../../../components/common/global_layout/footer'
import  { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink } from "react-router-dom";
import httpClient from "../../../../httpClient";

class QuatreX4 extends Component{ 
  constructor(props){
    super(props);
    this.state = {
     announces:[],
     searchInfo:{},
     searchedResult:true
    }
  }

  componentDidMount(){
    this.getAllAnnounces();
  }

  getAllAnnounces(){
    return httpClient.getAllCarsAnnounces().then(res=>{
      if(res){
        this.setState({announces:res})
      }
    })
  }


    render(){
      const carAnnounceId = this.props.match.params.id_car
      const ress = this.state.announces
      console.log(ress);
      const carsCards = ress.map(function(item, i){
        if (item.parJrs) {
          const AC = item.options.find(option => option === "Climatisation");
          return (
            <div className="col-6 col-md-3 mb-2 mt-2 p-1 p-sm-2">
            <CarCard
              className="typeCard"
              img="/imgs/carDetails/full.jpg"
              name={`${item.marque||""} ${item.model||""} ${item.anne||""}`}
              // price={"À partir de " + item.parJrs.prix + " DZD"}
              carLink={`/cars/${item._id}/carDetails/`}
              AC={AC}
              energie={item.energie}
            />
          </div>
        )}
        else 
        return (
          <div className="col-6 col-md-3 mb-2 mt-2 p-1 p-sm-2">
          <CarCard
            className="typeCard"
            img="/imgs/carDetails/full.jpg"
            name="4x4 Tucson 2021"
            price="5000 DA"
            carLink={"/cars/location/4X4/carDetails"}
          />
        </div>
      )
    }

      )
        return (
          <>
            <NavTab />
            <Container>
              <Container className="linksContainer d-none d-md-flex justify-content-start">
                <NavLink className="pageLinks" to="/">
                  Ghurfaty
                </NavLink>
                <FontAwesomeIcon
                  className="align-self-center faChevron"
                  icon={faChevronRight}
                ></FontAwesomeIcon>
                <NavLink className="pageLinks" to="/cars">
                  Véhicule
                </NavLink>
                <FontAwesomeIcon
                  className="align-self-center faChevron"
                  icon={faChevronRight}
                ></FontAwesomeIcon>
                <NavLink className="pageLinks" to="/cars/location">
                  Location
                </NavLink>
                <FontAwesomeIcon
                  className="align-self-center faChevron"
                  icon={faChevronRight}
                ></FontAwesomeIcon>
                <NavLink className="pageLinks" to="/cars/location/4x4">
                  4x4
                </NavLink>
              </Container>
              <AdvancedSearchLocation />
              <div className="container mb-3">
                <div className=" row typesCont d-flex justify-content-start">
                  {carsCards}
                </div>
              </div>
            </Container>
            <Footer />
          </>
        );
    }
}

export default QuatreX4;